import { render, staticRenderFns } from "./wtTwitterAsset.vue?vue&type=template&id=ed51b6f8&"
import script from "./wtTwitterAsset.vue?vue&type=script&lang=js&"
export * from "./wtTwitterAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports